<template>
    <div class="session__show_people">
        <base-filter
            :search-placeholder="$t('ebs.sessions.show.text.searchPeople')"
            :sort-active="false"
            :actions-active="true"
            :list-active="false"
            :info-active="sessionAllowBulkBookInfo && sessionAllowBulkBookPrivilege"
            :info-content="'You can book people to the session as long as it is not ended.'"
            :actions-secondary-button-active="false"
            :actions-primary-button-active="sessionAllowBulkBookPrivilege"
            :actions-primary-button-disabled="!sessionAllowBulkBookAction"
            :actions-primary-button-text="$t('ebs.sessions.show.buttons.bookPeople')"
            :actions-primary-button-animate-loading="false"
            @emit-actions-primary="openNotifyBookBulk"
        />
        <session-show-people-table
            :items="sessionPeople"
            @emit-view-booking-form="openNotifyViewBookingForm"
            @emit-remove-from-waitlist="openNotifyRemoveFromWaitlist"
            @emit-invite-person="openNotifyInvitePerson"
            @emit-book-person="openNotifyBookPerson"
            @emit-cancel-invite="openNotifyCancelInvite"
            @emit-resend-invite="openNotifyResendInvite"
            @emit-decline-booking="openNotifyDeclineBooking"
            @emit-approve-booking="openNotifyApproveBooking"
            @emit-cancel-booking="openNotifyCancelBooking"
            @emit-view-cancellation="openNotifyViewCancellation"
        />
        <template v-if="sessionAllowBulkBookAction">
            <pop-table
                ref="bookpeoplepop"
                :class="'session__show_people_bookpeoplepoptable'"
                :alert-message-active="isOldLMSToken && !sessionAllowNoEnrolments"
                :alert-message-text="$t('ebs.sessions.show.text.alertMustBe')"
                :content-text="$t('ebs.sessions.show.text.selectPeople')"
                :cancel-button-text="$t('ebs.sessions.show.buttons.close')"
                :eventbus-emit-name="'event-subscriptions'"
                :filter-search-placeholder="'Search users'"
                :filter-search-queryable="true"
                :get-pagination-getter="'getUsersPagination'"
                :get-items-getter="'getEnrolledUsersMappedIdNameStatus'"
                :get-items-getter-mapped="'getEnrolledUsersMappedLabelValue'"
                :get-items-dispatch="'getEnrolledUsers'"
                :item-name="['user', 'users']"
                :prevent-close="true"
                :submit-button-animate-loading="false"
                :submit-button-text="$t('ebs.sessions.show.buttons.bookPeople')"
                :title-text="$t('ebs.sessions.show.text.bookPeople')"
                :labels="[
                    {
                        key: 'name',
                        title: 'Name',
                        type: 'string',
                        sortable: true
                    },
                    {
                        key: 'email',
                        title: 'Email',
                        type: 'string',
                        sortable: true
                    }
                ]"
                :table-checkbox="true"
                :table-checkbox-name="'event-subscriptions'"
                @emit-selected="setPopTableSelected"
                @emit-submit="openBookBulkConfirm"
                @emit-request-finally="stopOrgUnitsApplyLoading"
            >
            </pop-table>
            <template v-if="sessionHasBookingForm">
                <pop-notify
                    ref="bookpeoplepopconfirmbookingform"
                    :title-text="$t('ebs.sessions.show.notify.bookPerson')"
                    :content-text="$t('ebs.sessions.show.notify.pleaseComplete')"
                    :form-active="true"
                    :form-fields="sessionBookingFormFields"
                    :cancel-button-text="$t('ebs.sessions.show.notify.cancel')"
                    :submit-button-text="$t('ebs.sessions.show.notify.bookOnto')"
                    :prevent-close="true"
                    @emit-form="updateBookingFields"
                    @emit-submit="createBooking"
                />
                <pop-notify
                    ref="bookpeoplepopconfirmbookingformdisabled"
                    :title-text="$t('ebs.sessions.show.notify.bookPeople')"
                    :content-text="$t('ebs.sessions.show.notify.textPeople')"
                    :cancel-button-text="$t('ebs.sessions.show.notify.cancel')"
                    :submit-button-text="$t('ebs.sessions.show.notify.bookOnto')"
                    :prevent-close="true"
                    @emit-submit="createBulkBooking"
                />
            </template>
            <template v-else>
                <pop-notify
                    :title-text="$t('ebs.sessions.show.notify.bulkBooking')"
                    :content-text="$t('ebs.sessions.show.notify.textBooking')"
                    :cancel-button-text="$t('ebs.sessions.show.notify.cancel')"
                    :submit-button-text="$t('ebs.sessions.show.notify.confirm')"
                    ref="bookpeoplepopconfirm"
                    @emit-submit="createBulkBooking"
                />
            </template>
        </template>
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.bookingForm')"
            :content-text="$t('ebs.sessions.show.text.davidBowie')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-active="false"
            ref="viewbookingformpop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.removeFromWaitlist')"
            :content-text="$t('ebs.sessions.show.text.areYouSureRemove')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.remove')"
            :submit-button-danger="true"
            ref="removefromwaitlistpop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.invitePerson')"
            :content-text="$t('ebs.sessions.show.text.areYouSureInvite')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.continue')"
            ref="invitepersonpop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.bookPerson')"
            :content-text="$t('ebs.sessions.show.text.areYouSureBook')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.continue')"
            ref="bookpersonpop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.cancelInvite')"
            :content-text="$t('ebs.sessions.show.text.areYouWontCancel')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.cancelInvite')"
            :submit-button-danger="true"
            ref="cancelinvitepop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.resendInvite')"
            :content-text="$t('ebs.sessions.show.text.areYouSureResend')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.continue')"
            ref="resendinvitepop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.declineBooking')"
            :content-text="$t('ebs.sessions.show.text.areYouSureDecline')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.declineRequest')"
            :submit-button-danger="true"
            ref="declinebookingpop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.approveBooking')"
            :content-text="$t('ebs.sessions.show.text.areYouSureApprove')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-text="$t('ebs.sessions.show.buttons.approveRequest')"
            ref="approvebookingpop"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.cancelBooking')"
            :content-text="$t('ebs.sessions.show.text.areYouSureCancel')"
            :cancel-button-text="$t('ebs.sessions.show.buttons.goBack')"
            :submit-button-text="$t('ebs.sessions.show.buttons.cancelBooking')"
            :submit-button-danger="true"
            ref="cancelbookingpop"
            :class="'pop__notify--booking'"
            :select-active="sessionCancellationReasonRequired"
            :select-value="bookingCancellationReason"
            :select-title="$t('ebs.sessions.show.title.cancellationReason')"
            :select-items="sessionCancellationReason"
            :select-items-other="sessionCancellationReasonOther"
            :prevent-close="true"
            @emit-select="updateBookingCancellationReason"
            @emit-select-other="updateBookingCancellationReasonOther"
            @emit-submit="cancelBooking"
        />
        <pop-notify
            :title-text="$t('ebs.sessions.show.title.cancellation')"
            :content-text="viewCancellationPopContent"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-active="false"
            ref="viewcancellationpop"
        />
    </div>
</template>

<script>
import BaseFilter from '@/components/default/filters/BaseFilter'
import SessionShowPeopleTable from '@/components/ebs/sessions/show/SessionShowPeopleTable'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'
import PopTable from '@/components/default/shared/PopTable'

export default {
  components: {
    PopTable,
    PopNotify,
    SessionShowPeopleTable,
    BaseFilter
  },
  name: 'session-show-people',
  data () {
    return {
      user: new User(),
      userBookingId: '',
      popTableSelected: ''
    }
  },
  computed: {
    isOldLMSToken () {
      return this.$store.getters.getAuthUserIsSecondStageTokenOldLMS
    },
    sessionAllowNoEnrolments () {
      return this.$store.getters.getSessionBookingAllowNoEnrolments
    },
    bookingFields () {
      return this.$store.getters.getBookingFields
    },
    bookingCancellationReason () {
      return this.$store.getters.getBookingCancellationReason
    },
    //
    sessionId () {
      return this.$store.getters.getSessionId
    },
    sessionBookingFormFields () {
      return this.$store.getters.getSessionBookingFormFields
    },
    sessionBookedLearners () {
      return this.$store.getters.getSessionBookedLearners
    },
    sessionPeople () {
      return this.$store.getters.getSessionPeople
    },
    sessionHasBookingForm () {
      return this.$store.getters.getSessionHasBookingForm
    },
    sessionAllowBulkBookInfo () {
      return this.$store.getters.getSessionAllowBulkBookInfo
    },
    sessionAllowBulkBookPrivilege () {
      return this.$store.getters.getSessionAllowBulkBookPrivilege
    },
    sessionAllowBulkBookAction () {
      return this.$store.getters.getSessionAllowBulkBookAction
    },
    sessionAvailableSpaces () {
      return this.$store.getters.getSessionSpacesAvailable
    },
    //
    sessionCancellationReasonRequired () {
      return this.$store.getters.getSessionCancellationReasonRequired
    },
    sessionCancellationReason () {
      const items = this.$store.getters.getSessionCancellationReason
      return this.fromStringToArraySelect(items)
    },
    sessionCancellationReasonOther () {
      return this.$store.getters.getSessionCancellationReasonOther
    },
    //
    userBooking () {
      return this.sessionBookedLearners.find(obj => obj.bookingId === this.userBookingId)
    },
    rawEnrolledUsers () {
      return this.$store.getters.getEnrolledUsers
    },
    //
    viewCancellationPopContent () {
      if (!this.userBooking) {
        return
      }
      const booking = this.userBooking
      const bookingName = `${booking.firstName} ${booking.lastName}`
      const bookingUpdated = new Date(booking.updatedAt).toLocaleDateString('en-gb', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short'
      })
      const bookingCancellationReason = booking.cancellationReason
      let content = ''
      content = `${bookingName} ${this.$t('ebs.sessions.show.description.bookingCancelled')} ${bookingUpdated} `
      if (bookingCancellationReason && bookingCancellationReason !== 'null') {
        content += `${this.$t('ebs.sessions.show.description.becauseReason')}\n` + `\n` + `"${bookingCancellationReason}"`
      }
      return content
    },
    allowBulkBookingSpacesAvailable () {
      return this.popTableSelected.length <= this.sessionAvailableSpaces
    }
  },
  methods: {
    setPopTableSelected (data) {
      this.popTableSelected = data
    },
    getBooking (bookingID) {
      this.$store.dispatch('getBooking', bookingID)
    },
    getEnrolledUsers () {
      this.$store.dispatch('getEnrolledUsers')
    },
    handleListExtraFilters (data) {
      this.listExtraFilters = data.length ? `filters[organisationUnitId]=${data.join(',')}` : ''
      setTimeout(() => {
        this.$refs.bookpeoplepop.$refs.componentlist.getItems()
      }, 10)
    },
    stopOrgUnitsApplyLoading () {
      this.$eventBus.$emit('stop-org-units-filter-apply')
    },
    //
    openNotifyBookBulk () {
      this.$refs.bookpeoplepop.openPop()
    },
    openNotifyViewBookingForm (id) {
      this.$refs.viewbookingformpop.openNotify()
    },
    openNotifyRemoveFromWaitlist (id) {
      this.$refs.removefromwaitlistpop.openNotify()
    },
    openNotifyInvitePerson (id) {
      this.$refs.invitepersonpop.openNotify()
    },
    openNotifyBookPerson (id) {
      this.$refs.bookpersonpop.openNotify()
    },
    openNotifyCancelInvite (id) {
      this.$refs.cancelinvitepop.openNotify()
    },
    openNotifyResendInvite (id) {
      this.$refs.resendinvitepop.openNotify()
    },
    openNotifyDeclineBooking (id) {
      this.$refs.declinebookingpop.openNotify()
    },
    openNotifyApproveBooking (id) {
      this.$refs.approvebookingpop.openNotify()
    },
    openNotifyCancelBooking (id) {
      this.getBooking(id)
      this.$refs.cancelbookingpop.openNotify()
    },
    openNotifyViewCancellation (id) {
      this.userBookingId = id
      this.$refs.viewcancellationpop.openNotify()
    },
    openBookBulkConfirm () {
      if (this.sessionHasBookingForm) {
        if (this.$refs.bookpeoplepop.selected.length > 1) {
          this.$refs.bookpeoplepopconfirmbookingformdisabled.openNotify()
        } else {
          if (!this.bookingFields.length) {
            this.setBookingFields()
          }
          this.$refs.bookpeoplepopconfirmbookingform.openNotify()
        }
      } else {
        this.$refs.bookpeoplepopconfirm.openNotify()
      }
    },
    closeNotifyCancelBooking () {
      this.$refs.cancelbookingpop.closeNotify()
    },
    closeBookBulkConfirm () {
      if (this.$refs.bookpeoplepopconfirmbookingformdisabled) {
        this.$refs.bookpeoplepopconfirmbookingformdisabled.closeNotify()
      }
      if (this.$refs.bookpeoplepopconfirmbookingform) {
        this.$refs.bookpeoplepopconfirmbookingform.closeNotify()
      }
    },
    //
    updateBookingCancellationReason (data) {
      this.$store.dispatch('setBookingCancellationReason', data)
    },
    updateBookingCancellationReasonOther (data) {
      this.$store.dispatch('setBookingCancellationReason', `other: ${data}`)
    },
    //
    setBookingFields () {
      this.$store.dispatch('setBookingFields')
    },
    updateBookingFields (data) {
      this.$store.dispatch('updateBookingFields', data)
    },
    //
    cancelBooking () {
      this.$store.dispatch('cancelBooking').then(() => {
        this.$eventBus.$emit('perform-get-session')
      }).finally(() => {
        this.closeNotifyCancelBooking()
      })
    },
    createBooking () {
      const selected = this.$refs.bookpeoplepop.selected[0].id
      this.$store.dispatch('createBooking', { learnerId: selected }).then(() => {
        this.$eventBus.$emit('perform-get-session')
      }).finally(() => {
        this.closeBookBulkConfirm()
      })
    },
    createBulkBooking () {
      const selected = this.$refs.bookpeoplepop.selected
      const selectedOutput = selected.map(obj => obj.id)
      this.$store.dispatch('createBulkBooking', selectedOutput).then(() => {
        this.$eventBus.$emit('perform-get-session')
      }).finally(() => {
        this.closeBookBulkConfirm()
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshowpeople";
</style>
